import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IonicPage, NavController, ToastController, AlertController, Loading, LoadingController } from 'ionic-angular';

import { User } from '../../providers';
import { MainPage } from '../';
import { ForgotPage } from '../forgot/forgot';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  // The account fields for the login form.
  // If you're using the username field with or without email, make
  // sure to add it to the type
  account: { email: string, password: string } = {
    email: '',
    password: ''
  };

  // Our translated text strings
  private loginErrorString: string;
  userData = {};
  loading: Loading;

  constructor(public navCtrl: NavController,
    public user: User,
    public toastCtrl: ToastController,
    public translateService: TranslateService,
    public alertCtrl: AlertController,
    public loadingController: LoadingController) {

    this.account = {
      email: '',
      password: ''
    };

    this.translateService.get('LOGIN_ERROR').subscribe((value) => {
      this.loginErrorString = value;
    })
  }

  ionViewDidLoad() {
    this.account = {
      email: '',
      password: ''
    };
  }

  validate() {
    console.log("validate email: "+this.account.email);
    console.log("validate password: "+this.account.password);
    if(this.account.email == null || this.account.email == "" || this.account.email == undefined) {
      console.log("invalid email: "+this.account.email);
      return false;
    } else if(this.account.password == null || this.account.password == "" || this.account.password == undefined) {
      console.log("invalid password: "+this.account.password);
      return false;
    } else {
      console.log("all valid!");
      return true;
    }
  }

  // Attempt to login in through our User service
  doLogin() {
    if(this.validate()){
      this.loading = this.loadingController.create({content : "Iniciando, porfavor espera un momento..."});
      this.loading.present();

      this.user.login(this.account).subscribe((resp) => {
        console.log("Ok: status: "+resp);
        console.log("Ok: data: "+ JSON.stringify(resp)); // data received by server
        //console.log("Ok: headers: "+resp.headers);
        //this.showAlert("Ok: "+JSON.stringify(resp), "Resp: "+resp);
        this.account = {
          email: '',
          password: ''
        };
        this.loading.dismissAll();
        this.navCtrl.setRoot(MainPage, { user : resp });
        this.navCtrl.popToRoot();
      }, (err) => {
        console.log("Ok: status: "+err);
        console.log("Ok: data: "+ JSON.stringify(err)); // data received by server
        //console.log("Ok: headers: "+resp.headers);
        //this.showAlert("Ok: "+JSON.stringify(err), "Resp: "+err);
        //this.navCtrl.push(MainPage);
        // Unable to log in

        if(err.error.error.statusCode == 401) {
          this.showAlert(err.error.error.name, "La contraseña es incorrecta.");
        } else {
          this.showAlert("Error",""+JSON.stringify(err));
        }
        let toast = this.toastCtrl.create({
          message: this.loginErrorString,
          duration: 3000,
          position: 'top'
        });
        this.loading.dismissAll();
        toast.present();
      });
    } else {
      this.showAlert("Faltan datos.","Debes llenar los datos para iniciar sesión.");
    }
  }

  showAlert(tit: string, msj: string) {
    const alert = this.alertCtrl.create({
      title: tit,
      subTitle: msj,
      buttons: ['Aceptar']
    });
    alert.present();
  }

  forgot(){
    this.navCtrl.push(ForgotPage);
  }

  crearCuenta(): void {
    this.navCtrl.push('SigningupPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts